// Сценарий описывает действие кассира; реквизиты чека проверяются сервером.
export const calculationEvent = (purpose) => ['prepayment','full_prepayment','advance','credit_payment'].includes(purpose) ? 'payment_now' : 'handover_now'

export function checkoutScenario(draft, totalMinor) {
    const { scenario, ...payload } = draft
    if (scenario === 'prepayment') {
        const amount = String(draft.prepayment_amount).trim().replace(',', '.')
        const parts = /^(\d+)(?:\.(\d{1,2}))?$/.exec(amount)
        const minor = parts ? Number(parts[1]) * 100 + Number((parts[2] || '').padEnd(2, '0')) : NaN
        payload.purpose = minor === Number(totalMinor) ? 'full_prepayment' : 'prepayment'
        payload.prepayment_amount = amount
    }
    return payload
}
